import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-448c3234"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-overview p-[16px] flex flex-col gap-[16px]" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-gordita-medium text-[16px] text-Text/text_high leading-normal" }, "Overview", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-overview',
  props: {
    containerClass: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["grid gap-[16px] items-container grid-rows-1", __props.containerClass])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})